import { render, staticRenderFns } from "./CustomFileDelete.vue?vue&type=template&id=4614787e&"
import script from "./CustomFileDelete.vue?vue&type=script&lang=js&"
export * from "./CustomFileDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports